import PropTypes from 'prop-types';

import withTheme from 'core/hocs/withTheme';

import { Desktop, Mobile } from 'core/components/breakpoint';

import styles from './index.styl';
import { resolveScopedStyles } from 'core/utils/styled-jsx';

function Title({ theme, title: customTitle }) {
  const emojiBarAtoms = theme.controls.reactionsEmojiBar;

  const scope = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .${styles.title}
          color ${emojiBarAtoms.title.color}
          font ${emojiBarAtoms.title.font}
      `}</style>
    </scope>
  );

  if (customTitle) {
    return (
      <h3 className={scope.wrapClassNames(styles.title)}>
        {customTitle}
        <scope.styles />
      </h3>
    );
  }

  return (
    <h3 className={scope.wrapClassNames(styles.title)}>
      <Desktop>
        Ваше отношение<br />к&nbsp;новости:
      </Desktop>
      <Mobile>
        Ваше отношение к&nbsp;новости:
      </Mobile>
      <scope.styles />
    </h3>
  );
}

Title.propTypes = {
  theme: PropTypes.object,
  title: PropTypes.string,
};

export default withTheme(Title);
